import { useLocation, useNavigate } from 'react-router-dom';
import { isEmpty, pickBy } from 'lodash';
import qs from 'qs';
import { useError } from 'hooks';

const useSearchParams = () => {
  const location = useLocation();
  const navigate = useNavigate();
  let searchParams = {};
  const { sendErrorSnack } = useError();

  const setSearchParams = (params, options = {}) => {
    const toLocation =
      location.pathname +
      (!isEmpty(pickBy(params))
        ? `?${qs.stringify(pickBy(params), { arrayFormat: 'indices' })}`
        : '');
    navigate(toLocation, options.replace ? { replace: true } : undefined);
  };

  try {
    searchParams = qs.parse(location.search.replace('?', ''));
  } catch (err) {
    sendErrorSnack(err);
  }

  return [searchParams, setSearchParams];
};

export default useSearchParams;
